import { Component } from "@angular/core";
import { ModalController} from "@ionic/angular";
import { Router } from "@angular/router";

@Component({
    selector: "bib-number",
    templateUrl: "bib-number.html",
    styleUrls:['./bib-number.scss']
})
export class BibNumberComponent {
    scope: any;
    viewClose: Promise<any> = null;
    constructor(private router:Router, private viewCtrl: ModalController) {
        const nav = this.router.getCurrentNavigation();
        const state = nav?.extras?.state || {};
        this.scope = state['scope'];
        this.viewClose = state['viewClose'];

        this.viewClose.then(() => {
            this.onDismiss();
        });
    }

    onDismiss() {
        this.viewCtrl.dismiss();
    }
}
